import { formatDateForCSV } from "./formatDateForCSV";

export const exportToCSV = (data, sum) => {
    
    // Δημιουργούμε το δεύτερο row με τα πεδία
    
    // Δημιουργούμε τα υπόλοιπα rows με τα στοιχεία δυναμικά
    
    const headerRow = `${formatDateForCSV(data[0]?.date)}\n`;
    const columnsRow = `Όνομα,Επίθετο,${data[0]?.meal_one.name},${data[0]?.meal_two.name},${data[0]?.meal_three.name},Άρτος Λευκός,Άρτος Ολικής,Σημείο Παραλαβής (Κωδικός),Σημείο Παραλαβής,Τηλέφωνο Επικοινωνίας\n`;
    // Δημιουργούμε τα rows με τα στοιχεία χρηστών που παρειγγειλαν
    const rows = data.map(item => (
        `${item?.first_name},${item?.last_name},${item?.quantity_one},${item?.quantity_two || ''},${item?.quantity_three || ''},${item?.bread_quantity},${item?.grained_bread_quantity},${item?.takeaway === "Κατανάλωση ΛΑΦΑ" ? 0 : item?.takeaway === "Παραλαβή ΣΠΑ" ? 1 : ""},${item?.takeaway},${item?.phone_number}\n`
    )).join('');
    const emptyZeroRow = `,,\n`;
    
    const sumRowText = `Συγκεντρωτικό,\n`;
    const sumRow = `Σημείο Παραλαβής,,${data[0]?.meal_one.name},${data[0]?.meal_two.name},${data[0]?.meal_three.name},Άρτος Λευκός,Άρτος Ολικής\n`;
    const sumSpa = `Παραλαβή (ΣΠΑ),,${sum?.orders_summary[data[0]?.meal_one.name].takeaway_spa},${sum?.orders_summary[data[0]?.meal_two.name].takeaway_spa},${sum?.orders_summary[data[0]?.meal_three.name].takeaway_spa},${sum?.orders_summary['Bread'].takeaway_spa},${sum?.orders_summary['grained_bread'].takeaway_spa},,\n`;
    const sumConsumeLafa = `Κατανάλωση (ΛΑΦΑ),,${sum?.orders_summary[data[0]?.meal_one.name].consume_lafa},${sum?.orders_summary[data[0]?.meal_two.name].consume_lafa},${sum?.orders_summary[data[0]?.meal_three.name].consume_lafa},${sum?.orders_summary['Bread'].consume_lafa},${sum?.orders_summary['grained_bread'].consume_lafa},,\n`;
    const sumTakeAwayLafa = `Παραλαβή (ΛΑΦΑ),,${sum?.orders_summary[data[0]?.meal_one.name].takeaway_lafa},${sum?.orders_summary[data[0]?.meal_two.name].takeaway_lafa},${sum?.orders_summary[data[0]?.meal_three.name].takeaway_lafa},${sum?.orders_summary['Bread'].takeaway_lafa},${sum?.orders_summary['grained_bread'].takeaway_lafa},,\n`;
    const totalRow = `Σύνολο,,${sum?.orders_summary[data[0]?.meal_one.name].total},${sum?.orders_summary[data[0]?.meal_two.name].total},${sum?.orders_summary[data[0]?.meal_three.name].total},${sum?.orders_summary['Bread'].total},${sum?.orders_summary['grained_bread'].total},,\n`;
    
    // Συνδυάζουμε τα header row και τα data rows
    const csvContent = headerRow + columnsRow + rows + emptyZeroRow +sumRowText+sumRow+ sumSpa+sumTakeAwayLafa+sumConsumeLafa + totalRow ;

    // Δημιουργία ενός αρχείου CSV
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    // Δημιουργία ενός προσωρινού element για το download
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', `Παραγγελίες_${data[0]?.date}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};